import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Message from '../components/Message';
import Loader from '../components/Loader';
import MainContainer from '../components/MainContainer';
import { getUserDetails, updateUserDetails } from '../actions/userActions';
import { trainingCentres } from '../constants/trainingCentres';

const ProfileScreen = ({ location, history }) => {
  const dispatch = useDispatch();
  const { loading, error, userInfo, success } = useSelector(
    (state) => state.user
  );
  const [name, setName] = useState(userInfo.name || '');
  const [email, setEmail] = useState(userInfo.email || '');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState(null);
  const [centre, setCentre] = useState(userInfo.centre);

  useEffect(() => {
    if (!loading && !userInfo) {
      history.push('/login');
    } else {
      if (!userInfo || !userInfo.name) {
        dispatch(getUserDetails('profile'));
      } else {
        setName(userInfo.name);
        setEmail(userInfo.email);
        setCentre(userInfo.centre);
      }
    }
  }, [dispatch, history, userInfo, success, loading]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage('Senhas não combinam');
    } else {
      dispatch(
        updateUserDetails({
          id: userInfo._id,
          name,
          email,
          password,
          centre,
        })
      );
    }
  };

  const getCentres = () => {
    return trainingCentres.sort().map((centre) => (
      <option value={centre} key={centre}>
        {centre}
      </option>
    ));
  };

  return (
    <MainContainer>
      <h1>Meus Dados</h1>
      {error && <Message variant='danger'>{error}</Message>}
      {message && <Message variant='danger'>{message}</Message>}
      {success && (
        <Message variant='success'>Dados atualizados com sucesso!</Message>
      )}
      {loading ? (
        <Loader />
      ) : (
        <Form onSubmit={submitHandler}>
          <Form.Group controlId='name'>
            <Form.Label>Nome</Form.Label>
            <Form.Control
              type='text'
              placeholder='Informe seu nome'
              value={name}
              onChange={(e) => setName(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId='email'>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type='email'
              placeholder='Informe seu email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId='centre'>
            <Form.Label>Núcleo</Form.Label>
            <Form.Control
              as='select'
              onChange={(e) => setCentre(e.target.value)}
              value={centre}
            >
              <option>...</option>
              {getCentres()}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId='password'>
            <Form.Label>Senha</Form.Label>
            <Form.Control
              type='password'
              placeholder='Informe sua senha'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId='confirmPassword'>
            <Form.Label>Confirmar Senha</Form.Label>
            <Form.Control
              type='password'
              placeholder='Confirme sua senha'
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Button type='submit' variant='primary'>
            Enviar
          </Button>
        </Form>
      )}
    </MainContainer>
  );
};

export default ProfileScreen;
